import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=fec3d1ae"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports